var borderRadius = props => {
  switch (props.rounded) {
    case 'small':
      return props.theme.component.borderRadiusSm;
    case 'medium':
      return props.theme.component.borderRadiusMd;
    case 'large':
      return props.theme.component.borderRadiusLg;
    case 'full':
      return props.theme.component.borderRadiusFull;
    default:
      return props.theme.component.borderRadiusMd;
  }
};
export default borderRadius;